import React from 'react';
import { NavLink } from 'react-router-dom';
import {
    AlignRight,
    Clipboard,
    FileText,
    Grid,
    Layers,
    PieChart,
    Power,
    Users,
} from 'react-feather';

export default function Sidebar() {
    return (
        <>
            <div className='dashboard-sidebar'>
                <div className='sidebar-menu'>
                    <ul>
                        <li>
                            <div>
                                <NavLink
                                    exact
                                    to='/'
                                    activeClassName='active'
                                    activeStyle={{
                                        color: 'var(--hover)',
                                        borderLeft: '3px solid var(--hover)',
                                        display: 'block',
                                    }}
                                >
                                    <Grid size={17} className='mr-3' />
                                    داشبورد
                                </NavLink>
                            </div>
                        </li>

                        <li>
                            <input type='checkbox' defaultChecked />

                            <i className='arrow' />

                            <h2>
                                <Layers className='mr-3' size={17} />
                                کامپوننت ها
                            </h2>

                            <div className='menu-item'>
                                <ul>
                                    <li>
                                        <NavLink
                                            to='/accordions'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            آکاردئون
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/alerts'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            اخطار و اطلاعیه
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/badge'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            برچسب ها
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/button'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            دکمه ها
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/listgroup'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            فهرست گروهی
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/modal'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            مودال ها
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/progress'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            نوار پیشرفت
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/tabs'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            تب ها
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        {/* <li>
                            <input type='checkbox' defaultChecked />

                            <i className='arrow' />

                            <h2>
                                <Cpu className='mr-3' size={17} />
                                اپلیکیشن ها
                            </h2>

                            <div className='menu-item'>
                                <ul>
                                    <li>
                                        <NavLink
                                            to='/chats'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            چت و گفتگو
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/email'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            ایمیل
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/todo'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            لیست TODO
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li> */}

                        <li>
                            <input type='checkbox' defaultChecked />

                            <i className='arrow' />

                            <h2>
                                <AlignRight className='mr-3' size={17} />
                                جداول
                            </h2>

                            <div className='menu-item'>
                                <ul>
                                    <li>
                                        <NavLink
                                            to='/table'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            جدول معمولی
                                        </NavLink>
                                    </li>

                                    <li>
                                        <a href='/'>جدول داده</a>
                                    </li>

                                    <li>
                                        <a href='/'>جدول ری‌اکت</a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li>
                            <input type='checkbox' defaultChecked />

                            <i className='arrow' />

                            <h2>
                                <Users className='mr-3' size={17} />
                                کاربر
                            </h2>

                            <div className='menu-item'>
                                <ul>
                                    <li>
                                        <NavLink
                                            to='/user'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            پروفایل کاربر
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/setting'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            تنظیمات کاربر
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink
                                            to='/bill'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            کیف پول کاربر
                                        </NavLink>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li>
                            <input type='checkbox' defaultChecked />

                            <i className='arrow' />

                            <h2>
                                <FileText className='mr-3' size={17} />
                                تمام صفحات
                            </h2>

                            <div className='menu-item'>
                                <ul>
                                    <li>
                                        <NavLink
                                            to='/user'
                                            activeClassName='active'
                                            activeStyle={{
                                                color: 'var(--hover)',
                                                borderLeft:
                                                    '3px solid var(--hover)',
                                                display: 'block',
                                            }}
                                        >
                                            پروفایل کاربر
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink to='/auth/login'>
                                            صفحه ورود
                                        </NavLink>
                                    </li>

                                    <li>
                                        <NavLink to='/auth/register'>
                                            ایجاد حساب
                                        </NavLink>
                                    </li>

                                    <li>
                                        <a href='/'>قفل صفحه</a>
                                    </li>

                                    <li>
                                        <a href='/'>ارور ۴۰۴</a>
                                    </li>

                                    <li>
                                        <a href='/'>ارور ۵۰۰</a>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li>
                            <div>
                                <NavLink
                                    to='/forms'
                                    activeClassName='active'
                                    activeStyle={{
                                        color: 'var(--hover)',
                                        borderLeft: '3px solid var(--hover)',
                                        display: 'block',
                                    }}
                                >
                                    <Clipboard className='mr-3' size={17} />
                                    انواع فرم
                                </NavLink>
                            </div>
                        </li>

                        <li>
                            <div>
                                <NavLink
                                    to='/chart'
                                    activeClassName='active'
                                    activeStyle={{
                                        color: 'var(--hover)',
                                        borderLeft: '3px solid var(--hover)',
                                        display: 'block',
                                    }}
                                >
                                    <PieChart className='mr-3' size={17} />
                                    نمودار ها
                                </NavLink>
                            </div>
                        </li>

                        <li className='d-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none'>
                            <div className='single-item'>
                                <NavLink to='/auth/login'>
                                    <Power className='mr-3' size={17} />
                                    خروج
                                </NavLink>
                            </div>
                        </li>
                    </ul>

                    <div className='single-item d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block'>
                        <NavLink to='/auth/login'>
                            <Power className='mr-3' size={17} />
                            خروج
                        </NavLink>
                    </div>
                </div>
            </div>
        </>
    );
}
